import {
  nodeLabel,
  visibleLabel,
  type MindmapNode,
} from '@/lib/mindmap-markdown';

/** Hidden children kept per node, for its fading lines to point at. */
export const PREVIEW_HIDDEN_CHILDREN = 2;
/** A hidden node is drawn wordless, so its pill is sized from this much of
 *  its label at most: long key points must not widen the map. */
export const PREVIEW_HIDDEN_CHARS = 6;

/**
 * The outline a preview lays out: every node above `hiddenFrom` (depth 0 is
 * the lesson), and below each node at `hiddenFrom - 1` at most
 * `PREVIEW_HIDDEN_CHILDREN` children with nothing under them, their labels
 * cut short. Those are drawn as faint, wordless pills; dropping the rest keeps
 * the layout as compact as what is actually drawn, so the map fits its box at
 * a readable size.
 */
export function pruneForPreview(
  node: MindmapNode,
  hiddenFrom: number,
  depth = 0
): MindmapNode {
  const children = node.children ?? [];
  if (depth + 1 < hiddenFrom) {
    return {
      ...node,
      children: children.map(c => pruneForPreview(c, hiddenFrom, depth + 1)),
    };
  }
  return {
    ...node,
    children: children.slice(0, PREVIEW_HIDDEN_CHILDREN).map(c => ({
      // Visible text: a cut `$..$` would be measured as broken TeX.
      content: visibleLabel(nodeLabel(c.content)).slice(
        0,
        PREVIEW_HIDDEN_CHARS
      ),
    })),
  };
}
